import { createContext } from "react";

const AdSetContext = createContext();

export default AdSetContext;
